// 组件全部使用的情报的， 这里页面先对studio这边能控制的部分做配置化（如显示隐藏，个别话术：如tips话术），情报的组件不做配置化改动
import React, { useEffect, useContext } from 'react';
import { PAGE_CONFIG_API } from '@home/_config/constant';
import CommonPageRender from '@home/components/CommonPageRender';
import { MOBILE_PAGE_CONFIG, PAGE_CONFIG } from './pageConfig';
import { ConfigProvider } from 'tea-component';
import { useIntl } from 'umi';
import { StudioContext } from '@home/pages/studio/context';
import StudioState from '../components/StudioState';

const PotentialMarket = () => {
  const { locale } = useIntl();
  const { currentGame, menuPermission } = useContext(StudioContext);
  const isMobile = currentGame?.game_type === 'mobile';
  const pageConfig = isMobile ? MOBILE_PAGE_CONFIG : PAGE_CONFIG;

  useEffect(() => {
    // 设置全局样式
    const element = document.querySelector('.dbh-studio-context');
    if (element) {
      (element as HTMLElement).style.backgroundColor = '#ebecf1';
    }
    return () => {
      // 去掉全局样式
      if (element) {
        (element as HTMLElement).style.backgroundColor = '#fff';
      }
    };
  }, []);

  if (menuPermission === false) {
    return <StudioState isNoPermission={true} />;
  }
  
  return (
    <ConfigProvider locale={locale === 'zh-CN' ? 'zh' : 'en'}>
      <CommonPageRender
        key={`${location.href}-${currentGame?.unified_edition_id || ''}`}
        className="dbh-studio-potential-market-page"
        reqParams='/potentialMarket'
        frameType="game"
        // @ts-ignore
        pageConfigInit={pageConfig}
        api={PAGE_CONFIG_API}
      />
    </ConfigProvider>
  );
};

export default PotentialMarket;
